// A dry run's writes, as the lines a person reads: what would be created,
// changed, deleted or linked had the Action really run.

// A dry run issues no sequence numbers; its keys hold a placeholder instead.
const UNISSUED_NUMBER = /<next [^>]*>/i;

const typeName = (type) => String(type || 'record').replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();

const recordName = (record = {}) => {
  const key = record.key && !UNISSUED_NUMBER.test(record.key) ? record.key : null;
  const label = key || (record.name ? `“${record.name}”` : '');
  return [typeName(record.type), label].filter(Boolean).join(' ');
};

const shown = (value) => (value === null || value === undefined || value === '' ? 'empty' : String(value));

const changeText = (changes = {}) => Object.entries(changes)
  .map(([field, change]) => `${field.replace(/_/g, ' ')} ${shown(change?.from)} → ${shown(change?.to)}`)
  .join(', ');

const LINES = {
  created: (record) => `Create ${recordName(record)}`,
  changed: (record) => `Change ${recordName(record)}${record.changes ? `: ${changeText(record.changes)}` : ''}`,
  deleted: (record) => `Delete ${recordName(record)}`,
  links_created: (link) => `Link ${recordName(link.from)} to ${recordName(link.to)}`,
  links_changed: (link) => `Change the link from ${recordName(link.from)} to ${recordName(link.to)}`,
  links_deleted: (link) => `Unlink ${recordName(link.from)} from ${recordName(link.to)}`,
};

export function dryRunLines(writes) {
  if (!writes || typeof writes !== 'object') return [];
  return Object.entries(LINES).flatMap(([kind, line]) => {
    const group = writes[kind];
    if (!group?.records?.length) return [];
    const lines = group.records.map(line);
    return group.more ? [...lines, `and ${group.more} more`] : lines;
  });
}
